//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    zone: Object
  }
}
